export default "__VITE_ASSET__BO1ejiUC__"